import { r as registerInstance, c as createEvent, h } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';

const gravityTagCss = ":host{display:inline-block;line-height:1}.gravity-tag{align-items:center;border-radius:2px;box-sizing:border-box;display:inline-flex;padding:4px 8px;--gravity-base-icon-size:14px}.gravity-tag--color-dark{background:#00162B}.gravity-tag--color-light{background:#FFFFFF}.gravity-tag--overflow-ellipsis{max-width:119px}.gravity-tag--size-small{padding:2px 8px}.gravity-tag--size-small.tag--overflow-ellipsis{max-width:119px}.gravity-tag--clickable{cursor:pointer;user-select:none}.gravity-tag--clickable.gravity-tag--color-dark{background:#1B6AEE}.gravity-tag--clickable.gravity-tag--color-dark:hover{background:#3279F0}.gravity-tag--clickable.gravity-tag--color-light{background:#DDE9FC}.gravity-tag--clickable.gravity-tag--color-light:hover{background:#F4F8FE}.gravity-tag__content--overflow-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.gravity-tag__icon{cursor:pointer;margin-left:4px}.gravity-tag__text{display:block;overflow:hidden}";
const GravityTagStyle0 = gravityTagCss;

const generateClassNames = bem('gravity-tag');
const GravityTag = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.tagClicked = createEvent(this, "tagClicked", 7);
        this.tagRemoved = createEvent(this, "tagRemoved", 7);
        this.tagText = '';
        this.clickable = false;
        this.color = 'dark';
        this.ellipsis = true;
        this.removable = false;
        this.size = 'large';
        this.iconColor = this.getTextColor();
        this.textMainColor = this.getTextColor();
    }
    handleColorChange() {
        this.textMainColor = this.getTextColor();
        this.iconColor = this.getTextColor();
    }
    handleMouseClick() {
        if (this.clickable) {
            this.tagClicked.emit(this.tagText);
        }
    }
    handleRemove() {
        this.tagRemoved.emit(this.tagText);
    }
    getTextColor() {
        if (this.color === 'dark') {
            return 'light';
        }
        return 'dark';
    }
    renderRemove() {
        if (this.removable) {
            return (h("gravity-icon", { color: this.iconColor, class: generateClassNames('icon'), size: "xxx-small", name: "close", onClick: this.handleRemove.bind(this) }));
        }
    }
    componentDidRender() {
        const slot = this.slotElement.querySelector('slot').assignedNodes()[0];
        this.tagText = '' + slot.textContent;
    }
    render() {
        return (h("span", { key: 'a281efb5ab818a34dd9d1b819c718b943aa15226', class: generateClassNames({
                'color': this.color,
                'size': this.size,
                'clickable': this.clickable,
                'removable': this.removable,
                'overflow-ellipsis': this.ellipsis,
            }) }, h("gravity-text", { key: '70b38402f519096f32cb4a5a0a8249c89760e6ac', size: 'xx-small', weight: 'medium', color: this.getTextColor(), class: generateClassNames('text', {
                'text--color': this.textMainColor,
            }), ref: (el) => el && (this.slotElement = el), onClick: this.handleMouseClick.bind(this) }, h("div", { key: '00e17271bb5491d77059ce47ea8ffbe94c401209', class: generateClassNames('content', {
                'overflow-ellipsis': this.ellipsis,
            }) }, h("slot", { key: '3fb67ead938522ce027969b1fd05f5d71179fa5c' }))), this.renderRemove()));
    }
    static get watchers() { return {
        "color": ["handleColorChange"]
    }; }
};
GravityTag.style = GravityTagStyle0;

export { GravityTag as gravity_tag };

//# sourceMappingURL=gravity-tag.entry.js.map